import React from 'react';
import styles from './styles.css';


const SortingControls = (props) => {
    const { columnId, onClick, columnName, sortedColumnId, sortDirection } = props;

    let sortingIcons;

    if (sortedColumnId !== columnId) {
        sortingIcons =
            <>
                <i aria-hidden={true} className={styles.caretUp + " caret up icon"} />
                <i aria-hidden={true} className={styles.caretDown + " caret down icon"}	/>
            </>;

    } else if (sortedColumnId === columnId && sortDirection === "asc") {
        sortingIcons = <i aria-hidden={true} className={`${styles.caretUp} ${styles.sorted} caret up icon`} />;
    } else {
        sortingIcons = <i aria-hidden={true} className={`${styles.caretDown} ${styles.sorted} caret down icon`} />;
    }

    return (
        <button
            type="button"
            className={styles.sortButton}
            onClick={() => onClick(columnId)}
        >
            {columnName}
            {sortingIcons}
        </button>
    );
};

export default SortingControls;